export const weatherTypes = {
	thunderstorm_with_light_rain: {
		type: 'Thunderstorm with light rain',
		icon: 'fas fa-thunderstorm',
		image: 'Thunderstorm.png',
		code: 'tc',
		consition: 200,
	},
	thunderstorm_with_rain: {
		type: 'Thunderstorm with rain',
		icon: 'fas fa-thunderstorm',
		image: 'Thunderstorm.png',
		code: 'tc',
		consition: 201,
	},
	thunderstorm_with_heavy_rain: {
		type: 'Thunderstorm with heavy rain',
		icon: 'fas fa-thunderstorm',
		image: 'Thunderstorm.png',
		code: 'tc',
		consition: 202,
	},
	thunderstorm_light: {
		type: 'Light thunderstorm',
		icon: 'fas fa-thunderstorm',
		image: 'Thunderstorm.png',
		code: 'tc',
		consition: 210,
	},
	thunderstorm: {
		type: 'Thunderstorm',
		icon: 'fas fa-thunderstorm',
		image: 'Thunderstorm.png',
		code: 'tc',
		consition: 211,
	},
	thunderstorm_heavy: {
		type: 'Heavy thunderstorm',
		icon: 'fas fa-thunderstorm',
		image: 'Thunderstorm.png',
		code: 'tc',
		consition: 212,
	},
	thunderstorm_ragged: {
		type: 'Ragged thunderstorm',
		icon: 'fas fa-thunderstorm',
		image: 'Thunderstorm.png',
		code: 'tc',
		consition: 221,
	},
	thunderstorm_with_light_drizzle: {
		type: 'Thunderstorm with light drizzle',
		icon: 'fas fa-thunderstorm',
		image: 'Thunderstorm.png',
		code: 'tc',
		consition: 230,
	},
	thunderstorm_with_drizzle: {
		type: 'Thunderstorm with drizzle',
		icon: 'fas fa-thunderstorm',
		image: 'Thunderstorm.png',
		code: 'tc',
		consition: 231,
	},
	thunderstorm_with_heavy_drizzle: {
		type: 'Thunderstorm with heavy drizzle',
		icon: 'fas fa-thunderstorm',
		image: 'Thunderstorm.png',
		code: 'tc',
		consition: 232,
	},
	drizzle_light_intensity: {
		type: 'Light intensity drizzle',
		icon: 'fas fa-cloud-drizzle',
		image: 'Drizzle.png',
		code: 'dc',
		consition: 300,
	},
	drizzle: {
		type: 'Drizzle',
		icon: 'fas fa-cloud-drizzle',
		image: 'Drizzle.png',
		code: 'dc',
		consition: 301,
	},
	drizzle_heavy_intensity: {
		type: 'Heavy intensity drizzle',
		icon: 'fas fa-cloud-drizzle',
		image: 'Drizzle.png',
		code: 'dc',
		consition: 302,
	},
	drizzle_light_intensity_rain: {
		type: 'Light intensity drizzle rain',
		icon: 'fas fa-cloud-drizzle',
		image: 'Drizzle.png',
		code: 'dc',
		consition: 310,
	},
	drizzle_rain: {
		type: 'Drizzle rain',
		icon: 'fas fa-cloud-drizzle',
		image: 'Drizzle.png',
		code: 'dc',
		consition: 311,
	},
	drizzle_heavy_intensity_rain: {
		type: 'Heavy intensity drizzle rain',
		icon: 'fas fa-cloud-drizzle',
		image: 'Drizzle.png',
		code: 'dc',
		consition: 312,
	},
	drizzle_shower_rain_and: {
		type: 'Shower rain and drizzle',
		icon: 'fas fa-cloud-drizzle',
		image: 'Drizzle.png',
		code: 'dc',
		consition: 313,
	},
	drizzle_heavy_shower_rain_and: {
		type: 'Heavy shower rain and drizzle',
		icon: 'fas fa-cloud-drizzle',
		image: 'Drizzle.png',
		code: 'dc',
		consition: 314,
	},
	drizzle_shower: {
		type: 'Shower drizzle',
		icon: 'fas fa-cloud-drizzle',
		image: 'Drizzle.png',
		code: 'dc',
		consition: 321,
	},
	rain_light: {
		type: 'Light rain',
		icon: 'fas fa-cloud-showers',
		image: 'Showers.png',
		code: 'rc',
		consition: 500,
	},
	rain_moderate: {
		type: 'Moderate rain',
		icon: 'fas fa-cloud-showers',
		image: 'Showers.png',
		code: 'rc',
		consition: 501,
	},
	rain_heavy_intensity: {
		type: 'Heavy intensity rain',
		icon: 'fas fa-cloud-showers',
		image: 'Showers.png',
		code: 'rc',
		consition: 502,
	},
	rain_very_heavy: {
		type: 'Very heavy rain',
		icon: 'fas fa-cloud-showers',
		image: 'Showers.png',
		code: 'rc',
		consition: 503,
	},
	rain_extreme: {
		type: 'Extreme rain',
		icon: 'fas fa-cloud-showers',
		image: 'Showers.png',
		code: 'rc',
		consition: 504,
	},
	rain_freezing: {
		type: 'Freezing rain',
		icon: 'fas fa-cloud-showers',
		image: 'Showers.png',
		code: 'rc',
		consition: 511,
	},
	rain_light_intensity_shower: {
		type: 'Light intensity shower rain',
		icon: 'fas fa-cloud-showers',
		image: 'Showers.png',
		code: 'rc',
		consition: 520,
	},
	rain_shower: {
		type: 'Shower rain',
		icon: 'fas fa-cloud-showers',
		image: 'Showers.png',
		code: 'rc',
		consition: 521,
	},
	rain_heavy_intensity_shower: {
		type: 'Heavy intensity shower rain',
		icon: 'fas fa-cloud-showers',
		image: 'Showers.png',
		code: 'rc',
		consition: 522,
	},
	rain_ragged_shower: {
		type: 'Ragged shower rain',
		icon: 'fas fa-cloud-showers',
		image: 'Showers.png',
		code: 'rc',
		consition: 531,
	},
	snow_light: {
		type: 'Light snow',
		icon: 'fas fa-snowflakes',
		image: 'Snowy.png',
		code: 'sc',
		consition: 600,
	},
	snow_snowy: {
		type: 'Snowy',
		icon: 'fas fa-snowflakes',
		image: 'Snowy.png',
		code: 'sc',
		consition: 601,
	},
	snow_heavy: {
		type: 'Heavy snow',
		icon: 'fas fa-snowflakes',
		image: 'Snowy.png',
		code: 'sc',
		consition: 602,
	},
	snow_sleet: {
		type: 'Sleet',
		icon: 'fas fa-snowflakes',
		image: 'Snowy.png',
		code: 'sc',
		consition: 611,
	},
	snow_light_shower_sleet: {
		type: 'Light shower sleet',
		icon: 'fas fa-snowflakes',
		image: 'Snowy.png',
		code: 'sc',
		consition: 612,
	},
	snow_shower_sleet: {
		type: 'Shower sleet',
		icon: 'fas fa-snowflakes',
		image: 'Snowy.png',
		code: 'sc',
		consition: 613,
	},
	snow_light_rain_and: {
		type: 'Light rain and snow',
		icon: 'fas fa-snowflakes',
		image: 'Snowy.png',
		code: 'sc',
		consition: 615,
	},
	snow_rain_and: {
		type: 'Rain and snow',
		icon: 'fas fa-snowflakes',
		image: 'Snowy.png',
		code: 'sc',
		consition: 616,
	},
	snow_light_shower: {
		type: 'Light shower snow',
		icon: 'fas fa-snowflakes',
		image: 'Snowy.png',
		code: 'sc',
		consition: 620,
	},
	snow_shower: {
		type: 'Shower snow',
		icon: 'fas fa-snowflakes',
		image: 'Snowy.png',
		code: 'sc',
		consition: 621,
	},
	snow_heavy_shower: {
		type: 'Heavy shower snow',
		icon: 'fas fa-snowflakes',
		image: 'Snowy.png',
		code: 'sc',
		consition: 622,
	},
	mist: {
		type: 'Mist',
		icon: 'fas fa-fog',
		image: 'Foggy.png',
		code: 'ac',
		consition: 701,
	},
	smoke: {
		type: 'Smoke',
		icon: 'fas fa-fog',
		image: 'Foggy.png',
		code: 'ac',
		consition: 711,
	},
	haze: {
		type: 'Haze',
		icon: 'fas fa-fog',
		image: 'Foggy.png',
		code: 'ac',
		consition: 721,
	},
	dust_whirls: {
		type: 'Sand/dust whirls',
		icon: 'fas fa-fog',
		image: 'Foggy.png',
		code: 'ac',
		consition: 731,
	},
	fog: {
		type: 'Fog',
		icon: 'fas fa-fog',
		image: 'Foggy.png',
		code: 'ac',
		consition: 741,
	},
	sand: {
		type: 'Sand',
		icon: 'fas fa-fog',
		image: 'Foggy.png',
		code: 'ac',
		consition: 751,
	},
	dust: {
		type: 'Dust',
		icon: 'fas fa-fog',
		image: 'Foggy.png',
		code: 'ac',
		consition: 761,
	},
	volcanic_ash: {
		type: 'Volcanic ash',
		icon: 'fas fa-fog',
		image: 'Foggy.png',
		code: 'ac',
		consition: 762,
	},
	squalls: {
		type: 'Squalls',
		icon: 'fas fa-fog',
		image: 'Foggy.png',
		code: 'ac',
		consition: 771,
	},
	tornado: {
		type: 'Tornado',
		icon: 'fas fa-fog',
		image: 'Foggy.png',
		code: 'ac',
		consition: 781,
	},
	clear: {
		type: 'Clear sky',
		icon: 'fas fa-sun',
		image: 'Sunny.png',
		code: 'cci',
		consition: 800,
	},
	few: {
		type: 'Partly cloudy',
		icon: 'fas fa-clouds',
		image: 'Cloudy.png',
		code: 'cci',
		consition: 801,
	},
	scattered: {
		type: 'Cloudy',
		icon: 'fas fa-clouds',
		image: 'Cloudy.png',
		code: 'cci',
		consition: 802,
	},
	broken: {
		type: 'Mostly cloudy',
		icon: 'fas fa-clouds',
		image: 'Cloudy.png',
		code: 'cci',
		consition: 803,
	},
	overcast: {
		type: 'Overcast',
		icon: 'fas fa-clouds',
		image: 'Cloudy.png',
		code: 'cci',
		consition: 804,
	},
};
